export default __webpack_public_path__ + "static/media/PhD_positions_movement_ecology_NTU.00bf9e74.pdf";